import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"

export default function PasswordStrength(props) {
  let { password } = props;
  const [passAnalysis, setPassAnalysis] = useState({});

  useEffect(() => {
    let StrengthData = PassStrength(password);
    setPassAnalysis(StrengthData);
  }, [password]);

  const PassStrength = (pass) => {
    const hasUpperCase = (str) => {
      return str.toLowerCase() !== str;
    };
    let Splchars = new RegExp(/([!,%,&,@,#,$,^,*,?,_,~])/);
    let intReg = new RegExp(/(?=.*[0-9])/);
    let pdStrength = "";
    let Strength = 0;
    if (pass.length !== "") {
      if (pass.length >= 3) {
        pdStrength = "Very Weak";
        Strength++;
      }
      if (pass.length >= 6 && (pass.match(intReg) || hasUpperCase(pass))) {
        pdStrength = "Weak";
        Strength++;
      }
      if (pass.match(intReg) && hasUpperCase(pass) && pass.length >= 8) {
        pdStrength = "Good";
        Strength++;
      }
      if (
        pass.match(intReg) &&
        hasUpperCase(pass) &&
        pass.match(Splchars) &&
        pass.length >= 8
      ) {
        pdStrength = "Strong";
        Strength++;
      }
    }
    return { pdStrength, Strength };
  };

  const RenderStrengthColor = (strength) => {
    let color = "";
    switch (strength) {
      case "Very Weak":
        color = "#ef4836";
        break;
      case "Weak":
        color = "#f96969";
        break;
      case "Good":
        color = "#f6b44d";
        break;
      case "Strong":
        color = "#25c281";
        break;
    }
    return color;
  };
  if (Object.keys(passAnalysis).length !== 0) {
    return (
      <div className="password-strength-container">
        <p
          style={{
            color: RenderStrengthColor(passAnalysis.passwordStrength),
            fontWeight: 500,
          }}
        >
          {passAnalysis.passwordStrength}
        </p>
        {passAnalysis.passwordStrength !== "" ? (
          <label>&nbsp;</label>
        ) : null}
      </div>
    );
  } else {
    return null;
  }
}

PasswordStrength.propTypes = {
  password: PropTypes.any
}